// extracted by mini-css-extract-plugin
export default {"general":"MenuItems_general__MvHXM"};